// Auto-generated by scripts/write-git-version.mjs
export const gitVersion = {
  "sha": "a5995faa48c99e6958ac2ac87adb8dd1dd8cc033",
  "branch": "dev",
  "dirty": true,
  "buildTime": "2026-10-21T12:01:23.035Z"
};
export default gitVersion;
